import { Tooltip } from 'devextreme-react/tooltip';
export const formatTooltip = (id: string, text: string | undefined) => (
    <Tooltip
        target={`[data-for="${id}"]`}
        showEvent='mouseenter'
        hideEvent='mouseleave'
        hideOnOutsideClick={false}
    >
        {text}
    </Tooltip>
);
